import { Link } from '@mui/material';
import { createLink } from '@tanstack/react-router';

const NavLink = createLink(Link);

export default NavLink;
